import React from "react";
import {
  Radio,
  FormControl,
  RadioGroup,
  FormControlLabel,
  FormLabel
} from "@material-ui/core";


function TelePhoneCompany(props) {

    return ( 
        <FormControl>
            <FormLabel>통신사</FormLabel>
            <RadioGroup
                row
                aria-label="TeleCompany"
                name="TeleCompany"
                disabled={props.SelfCertification}
                variant="filled"
                value={props.TeleCompanyCode}
                onChange={(e) => {
                    
                    props.onChanTeleCompany(e.target.value)
                }}
            >
        <FormControlLabel disabled={props.SelfCertification} value="01" control={<Radio />} label="SKT" />
        <FormControlLabel disabled={props.SelfCertification} value="02" control={<Radio />} label="KT" />
        <FormControlLabel disabled={props.SelfCertification} value="03" control={<Radio />} label="LGT" />
        <FormControlLabel disabled={props.SelfCertification} value="04" control={<Radio />} label="SKT(알뜰폰)" />
        <FormControlLabel disabled={props.SelfCertification} value="05" control={<Radio />} label="KT(알뜰폰)" />
        <FormControlLabel disabled={props.SelfCertification} value="06" control={<Radio />} label="LGT(알뜰폰)" />
      </RadioGroup>
    </FormControl>
     );
}


export default TelePhoneCompany
